import React from "react";

const Warning = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-clock"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-clock"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm2.5,16.33c-.157,.091-.329,.134-.499,.134-.346,0-.682-.179-.867-.5l-2-3.464c-.088-.152-.134-.324-.134-.5V6c0-.552,.447-1,1-1s1,.448,1,1v5.732l1.866,3.232c.276,.478,.112,1.09-.366,1.366Z" />
    </svg>
  );
};

export default Warning;
